import ReactGA from 'react-ga4'

ReactGA.initialize('G-7KPTY9L464')
